// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H-jz","rootNoMargin":"styles_rootNoMargin__y6Umm"};